import * as core from '../../../../../../../core'
import * as pullRequestKind from '../pull-request-kind'

export const RESOURCE = {
  payload: {
    description:
      'Contains code; merging it implements the requirements it closes',
    enumId: core.dms.models.Enum.Id.from({
      partialId: pullRequestKind.RESOURCE.payload.partialId,
    }),
    id: 'IMPLEMENTATION',
    name: 'Implementation',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
